import { useCallback } from 'react';

/**
 * Currency + percentage formatting helpers bound to a currency code.
 * Defaults to USD; pass the shop currency from useShop.
 */
export function useCurrency(currencyCode = 'USD') {
  const formatMoney = useCallback(
    (amount: number | string | null | undefined): string => {
      const value = typeof amount === 'string' ? parseFloat(amount) : amount ?? 0;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode,
      }).format(Number.isFinite(value) ? value : 0);
    },
    [currencyCode],
  );

  const formatPercent = useCallback(
    (ratio: number | string | null | undefined): string => {
      const value = typeof ratio === 'string' ? parseFloat(ratio) : ratio ?? 0;
      return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      }).format(Number.isFinite(value) ? value : 0);
    },
    [],
  );

  return { formatMoney, formatPercent };
}
